import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import axios from "axios";
import storage from 'good-storage'
import 'element-ui/lib/theme-chalk/index.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';


Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.component(CollapseTransition.name, CollapseTransition)

Vue.prototype.storage = storage;

// 使用axios
Vue.prototype.axios = axios;
// 配置公共请求地址
Vue.prototype.baseURL = process.env.API_ROOT;

Vue.prototype.$http = axios
Vue.prototype.$imgUrl = 
  process.env.NODE_ENV === "development" ? "http://www.xazkrj.cn/" : "/";
  

Vue.prototype.$api =
  process.env.NODE_ENV === "development" ? "api" : "";

Vue.prototype.axiosRequest = function (methods, url, params, callback) {
  axios({
    method: methods,
    url: this.$api + url,
    headers: { "X-Requested-With": "XMLHttpRequest" },
    params: params
  })
    .then(response => {
      callback(response);
    })
    .catch(error => {
      // errFun(error);
    });
}



new Vue({
  router,
  // data: function () {
  //   return {
  //     lanmuID: 9999,
  //   }
  // },
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js